import { AxiosInstance, AxiosResponse } from "axios";

/** A backbone site, by its commercial label. Router names never reach here. */
export interface LatencySite {
    id: string;
    label: string;
    city: string | null;
    country: string | null;
}

/**
 * RTT between two sites: the lowest among their router pairs, along the
 * IGP path (algo 0, DEFAULT). One entry per unordered pair, `from` < `to`;
 * a pair with no measurable router pair is absent.
 */
export interface SiteLatencyEntry {
    from: string;
    to: string;
    rttUs: number;
    oneWayUs: { forward: number; reverse: number };
    /** Same path summed over the link baseline; null when a hop lacks one. */
    baselineRttUs: number | null;
}

export interface SiteLatencyMatrixData {
    metric: "igp";
    /** Timestamp of the IS-IS snapshot the matrix was computed from. */
    measuredAt: string | null;
    sites: LatencySite[];
    matrix: SiteLatencyEntry[];
}

interface SiteLatencyMatrixResponse {
    success: boolean;
    message: string;
    data: SiteLatencyMatrixData | null;
}

/** GET /kontroledge/monitoring/site-latency-matrix (partner-gated). */
export function getSiteLatencyMatrixAPI(
    api: AxiosInstance
): Promise<AxiosResponse<SiteLatencyMatrixResponse>> {
    return api.get("/kontroledge/monitoring/site-latency-matrix");
}
